import { IQuestionBankSection } from 'interfaces/questionBank'

export function calculateSectionTotals(section: IQuestionBankSection) {
  if (section.randomOrder)
    return {
      totalQuestions: section.randomQuestionsToDisplay,
      score: section.scoreForEachQuestion * section.randomQuestionsToDisplay,
    }

  return {
    totalQuestions: section.questions.length,
    score: section.questions.reduce(
      (acc, question) => acc + (question.score || 0),
      0
    ),
  }
}
